/**
 * @generated SignedSource<<869113d03afc3bdff09218d066ab3325>>
 * @relayHash af5450d90432669b7696e3aa095ea9a0
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af5450d90432669b7696e3aa095ea9a0

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteMedicalReportAttachmentInput = {
  id: string;
};
export type deDeleteMedicalReportMutation$variables = {
  connections: ReadonlyArray<string>;
  input: De_deleteMedicalReportAttachmentInput;
};
export type deDeleteMedicalReportMutation$data = {
  readonly deleteMedicalReport: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly medicalReportAttachment: {
      readonly id: string;
    } | null;
  };
};
export type deDeleteMedicalReportMutation = {
  response: deDeleteMedicalReportMutation$data;
  variables: deDeleteMedicalReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deDeleteMedicalReportMutation",
    "selections": [
      {
        "alias": "deleteMedicalReport",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteMedicalReportAttachmentPayload",
        "kind": "LinkedField",
        "name": "de_deleteMedicalReportAttachment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MedicalReportAttachment",
            "kind": "LinkedField",
            "name": "medicalReportAttachment",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deDeleteMedicalReportMutation",
    "selections": [
      {
        "alias": "deleteMedicalReport",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteMedicalReportAttachmentPayload",
        "kind": "LinkedField",
        "name": "de_deleteMedicalReportAttachment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MedicalReportAttachment",
            "kind": "LinkedField",
            "name": "medicalReportAttachment",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "af5450d90432669b7696e3aa095ea9a0",
    "metadata": {},
    "name": "deDeleteMedicalReportMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6a6332bf0e98a5230208c8c572950214";

export default node;
